import { memo } from "react";
import PropTypes from "prop-types";
import { Box, styled } from "@mui/material";
import { FormatConstant, SystemConstant } from "const";
import PersonalCallHistory from "./PersonalCallHistory";
import ChatItem from "./ChatItem";
import LineChat from "./LineChat";
import { convertLineChatTime } from "utils/date.utils";
import StringFormat from "string-format";
import PinMessage from "./ChatItem/PinMessage";
import LeaveGroupMessage from "./ChatItem/LeaveGroupMessage";
import DisappearMessageNotice from "./ChatItem/DisappearMessageNotice";
import ScreenCaptureMessage from "./ChatItem/ScreenCaptureMessage";
import AddMemberMessage from "./ChatItem/AddMemberMessage";

const MessageItem = ({ message, isThreadMode, isSearchMode }) => {
  const isSkipDeletedMessage = Boolean(isSearchMode && message.isDeleteAll);
  const isSkipMessage =
    isSkipDeletedMessage ||
    (Boolean(isThreadMode || isSearchMode) &&
      [
        SystemConstant.SEND_TYPE.pinMessage,
        SystemConstant.SEND_TYPE.leaveGroup,
        SystemConstant.SEND_TYPE.screenCapture,
        SystemConstant.SEND_TYPE.disappearMessage,
      ].includes(message.sendType));
  const isShowTime = message.isShowTime && message.state === SystemConstant.STATE.active;
  if (isSkipMessage) return null;
  return (
    <MessageContainer id={StringFormat(FormatConstant.FM_CHAT_ITEM_ID, message.parentId || message.sourceId)}>
      {isShowTime && <LineChat data={convertLineChatTime(message.created)} />}

      {SystemConstant.ARR_CALLING_TYPES.includes(message.sendType) ? (
        Boolean(message.senderId) && <PersonalCallHistory data={message} />
      ) : message.sendType === SystemConstant.SEND_TYPE.pinMessage ? (
        <PinMessage message={message} />
      ) : message.sendType === SystemConstant.SEND_TYPE.leaveGroup ? (
        <LeaveGroupMessage message={message} />
      ) : message.sendType === SystemConstant.SEND_TYPE.screenCapture ? (
        <ScreenCaptureMessage message={message} />
      ) : message.sendType === SystemConstant.SEND_TYPE.disappearMessage ? (
        <DisappearMessageNotice message={message} />
      ) : message.sendType === SystemConstant.SEND_TYPE.addMemberToGroup ? (
        <AddMemberMessage message={message} />
      ) : (
        <ChatItem data={message} isThreadMode={isThreadMode} isSearchMode={isSearchMode} />
      )}
    </MessageContainer>
  );
};

MessageItem.prototype = {
  message: PropTypes.object,
  isThreadMode: PropTypes.bool,
};
export default memo(MessageItem);

const MessageContainer = styled(Box)({
  position: "relative",
  width: "100%",
});
